module.exports = __webpack_public_path__ + "static/media/highlights-4.02813d83.png";